module.exports = __webpack_public_path__ + "img/device-icon.cbab1a31.png";